import React from 'react';
import HeroSection from '../../HeroSection';
import Pricing from '../../Pricing';
import { homeObjOne, homeObjThree, homeObjTwo, homeObjFour } from './Data';
import Footer from '../Footer/Footer' 

function contactUs() {
    return (
        <>
         
       
          

        </>
    )
}

export default contactUs;
